import { AfterViewInit, ChangeDetectorRef, Component, Input, OnInit, QueryList, ViewChildren, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ArtifactAssemblyTypes, AssemblyArtifact } from '../models/artifact';
import { DeveloperArtifactService } from '../services/developer-artifact.service';
import { DocumentConfigOutBatcher } from '../models/document-config-out-batcher';
import { DeveloperService } from '../services/developer.service';
import { DataFieldGroup } from '../../shared/datafields/models';
import { LoadingPanelService } from '../../shared/loading-panel/loading-panel.service';
import { ToastService, ToastType } from '../../shared/toast/toast.service';
import { DeveloperDocumentConfigBatchingTypeComponent } from './developer-document-configs-batching-type.component';
import { BehaviorSubject } from 'rxjs';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { distinctUntilChanged } from 'rxjs/operators';


@Component({
    templateUrl: './developer-document-configs-batching.component.html',
    styleUrls: ['./developer-document-configs-batching.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DeveloperDocumentConfigBatchingTypeComponent]
})

export class DeveloperDocumentConfigBatchingComponent implements AfterViewInit {

    @Input() documentConfigOutId: number;

    @ViewChildren(DeveloperDocumentConfigBatchingTypeComponent) documentConfigBatchingTypeComponent: QueryList<DeveloperDocumentConfigBatchingTypeComponent>;

    artifacts: AssemblyArtifact[] = [];
    documentConfigOutBatchers: DocumentConfigOutBatcher[] = [];
    displayDocumentConfigOutBatchers: DocumentConfigOutBatcher[] = [];
    formGroup: UntypedFormGroup;
    isFormValid: boolean = false;


    constructor(    
        private cdr: ChangeDetectorRef,  
        private formBuilder: UntypedFormBuilder,
        private loadingPanelService: LoadingPanelService,
        private toastService: ToastService,
        private activeModal: NgbActiveModal,
        private developerService: DeveloperService,
        private developerArtifactService: DeveloperArtifactService) {
    }

    async ngAfterViewInit(): Promise<void> {
        await this.loadData();
        await this.prepareForm();
    }

    async prepareForm(): Promise<void>{
        this.formGroup = this.formBuilder.group({
            batchers: this.formBuilder.array([])
        });

        setTimeout(() =>{
            this.documentConfigBatchingTypeComponent?.toArray().forEach(d => {
                let batchersArray = this.formGroup.controls.batchers as UntypedFormArray;
                let arrayLen = batchersArray.length;
                batchersArray.insert(arrayLen, d.formGroup);
            });
        });

        this.isFormValid = this.formGroup.valid;

        this.formGroup.statusChanges
        .pipe(distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b)))
        .subscribe(result => {
            this.isFormValid = (result === 'VALID');
            //this.cdr.detectChanges();
        });
        this.cdr.detectChanges();
    }

    async loadData(): Promise<void> {
        try {
            setTimeout(() =>{
                this.loadingPanelService.showLoadingPanelDirect('Loading...');  
            });
            
            this.artifacts = await this.developerArtifactService.getAssemblyArtifacts(true, [ArtifactAssemblyTypes.TypeBatcher]);
            this.documentConfigOutBatchers = await this.developerService.getDocumentConfigOutBatchers(this.documentConfigOutId);

            for (const artifact of this.artifacts) {
                const existingBatcher = this.documentConfigOutBatchers.filter(batcher => batcher.ArtifactId == artifact.ArtifactId)[0];
                if (existingBatcher == undefined || existingBatcher == null) {
                    const dataFields = await this.developerService.getBatcherDataFieldGroups(artifact.ArtifactId, null);
                    this.documentConfigOutBatchers.push({Id: null, DocumentConfigId: this.documentConfigOutId, ArtifactId: artifact.ArtifactId, ArtifactName: artifact.Name, ConfigurationDataFields: dataFields, ConfigurationDataFieldValues: [], Enabled: false } as DocumentConfigOutBatcher)
                } else {
                    existingBatcher.ConfigurationDataFields = await this.developerService.getBatcherDataFieldGroups(existingBatcher.ArtifactId, existingBatcher.Id);
                    existingBatcher.Enabled = true;
                }
            }
            this.displayDocumentConfigOutBatchers = this.documentConfigOutBatchers;
        }
        catch (err) {
            console.error(err);
            this.toastService.showToast('Failed to load data...', ToastType.error);
        }
        finally {
            this.loadingPanelService.hideLoadingPanel();
        }
    }

    cancel() {
        this.activeModal.dismiss();
    }

    async save() {
        try {
            this.documentConfigOutBatchers.forEach(b => b.ConfigurationDataFieldValues = DataFieldGroup.getDataFieldValues(b.ConfigurationDataFields, false))
            await this.developerService.saveBatchers(this.documentConfigOutBatchers);
            this.activeModal.dismiss();
            this.toastService.showToast('Batch configuration saved...', ToastType.success);
        }
        catch {
            this.toastService.showToast('Failed to save batch configuration...', ToastType.error);
        }
    }
}
